import React from "react";
import PropTypes from "prop-types";

const Chevron = ({ small = false }) => {
  const size = small ? 16 : 24;
  const path = small ? "M3 6l5 5 5-5" : "M5 9l7 7 7-7";

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} xmlns="http://www.w3.org/2000/svg">
      <path fill="none" stroke="#808080" strokeWidth="2" d={path}/>
    </svg>
  );
};

Chevron.propTypes = {
  small: PropTypes.bool
};

export default Chevron;
